/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builds_Timeline_BaselineInputs */

const id_builds_timeline_baseline = /** @type {(inputs: Builds_Timeline_BaselineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baseline`)
};

const ms_builds_timeline_baseline = /** @type {(inputs: Builds_Timeline_BaselineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baseline`)
};

const da_builds_timeline_baseline = /** @type {(inputs: Builds_Timeline_BaselineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baseline`)
};

const de_builds_timeline_baseline = /** @type {(inputs: Builds_Timeline_BaselineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baseline`)
};

const en_us2_builds_timeline_baseline = /** @type {(inputs: Builds_Timeline_BaselineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baseline`)
};

const es_es2_builds_timeline_baseline = /** @type {(inputs: Builds_Timeline_BaselineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compilación de referencia`)
};

const es_mx2_builds_timeline_baseline = /** @type {(inputs: Builds_Timeline_BaselineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Base`)
};

const fil_builds_timeline_baseline = /** @type {(inputs: Builds_Timeline_BaselineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baseline`)
};

const fr_builds_timeline_baseline = /** @type {(inputs: Builds_Timeline_BaselineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baseline`)
};

const it_builds_timeline_baseline = /** @type {(inputs: Builds_Timeline_BaselineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baseline`)
};

const hu_builds_timeline_baseline = /** @type {(inputs: Builds_Timeline_BaselineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baseline`)
};

const nl_builds_timeline_baseline = /** @type {(inputs: Builds_Timeline_BaselineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baseline`)
};

const no_builds_timeline_baseline = /** @type {(inputs: Builds_Timeline_BaselineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baseline`)
};

const pl_builds_timeline_baseline = /** @type {(inputs: Builds_Timeline_BaselineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baseline`)
};

const pt_br2_builds_timeline_baseline = /** @type {(inputs: Builds_Timeline_BaselineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baseline`)
};

const pt_builds_timeline_baseline = /** @type {(inputs: Builds_Timeline_BaselineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baseline`)
};

const ro_builds_timeline_baseline = /** @type {(inputs: Builds_Timeline_BaselineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baseline`)
};

const fi_builds_timeline_baseline = /** @type {(inputs: Builds_Timeline_BaselineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baseline`)
};

const sv_builds_timeline_baseline = /** @type {(inputs: Builds_Timeline_BaselineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baseline`)
};

const vi_builds_timeline_baseline = /** @type {(inputs: Builds_Timeline_BaselineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baseline`)
};

const tr_builds_timeline_baseline = /** @type {(inputs: Builds_Timeline_BaselineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baseline`)
};

const cs_builds_timeline_baseline = /** @type {(inputs: Builds_Timeline_BaselineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baseline`)
};

const bg_builds_timeline_baseline = /** @type {(inputs: Builds_Timeline_BaselineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baseline`)
};

const ru_builds_timeline_baseline = /** @type {(inputs: Builds_Timeline_BaselineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Базовый уровень для сравнения`)
};

const uk_builds_timeline_baseline = /** @type {(inputs: Builds_Timeline_BaselineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baseline`)
};

const ar_builds_timeline_baseline = /** @type {(inputs: Builds_Timeline_BaselineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baseline`)
};

const hi_builds_timeline_baseline = /** @type {(inputs: Builds_Timeline_BaselineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बेसलाइन`)
};

const th_builds_timeline_baseline = /** @type {(inputs: Builds_Timeline_BaselineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ฐานเปรียบเทียบ`)
};

const ja_builds_timeline_baseline = /** @type {(inputs: Builds_Timeline_BaselineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baseline`)
};

const zh_cn2_builds_timeline_baseline = /** @type {(inputs: Builds_Timeline_BaselineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baseline`)
};

const zh_hant1_builds_timeline_baseline = /** @type {(inputs: Builds_Timeline_BaselineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`基準`)
};

const ko_builds_timeline_baseline = /** @type {(inputs: Builds_Timeline_BaselineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baseline`)
};

/**
* | output |
* | --- |
* | "Baseline" |
*
* @param {Builds_Timeline_BaselineInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const builds_timeline_baseline = /** @type {((inputs?: Builds_Timeline_BaselineInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builds_Timeline_BaselineInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_builds_timeline_baseline(inputs)
	if (locale === "ms") return ms_builds_timeline_baseline(inputs)
	if (locale === "da") return da_builds_timeline_baseline(inputs)
	if (locale === "de") return de_builds_timeline_baseline(inputs)
	if (locale === "en-US") return en_us2_builds_timeline_baseline(inputs)
	if (locale === "es-ES") return es_es2_builds_timeline_baseline(inputs)
	if (locale === "es-MX") return es_mx2_builds_timeline_baseline(inputs)
	if (locale === "fil") return fil_builds_timeline_baseline(inputs)
	if (locale === "fr") return fr_builds_timeline_baseline(inputs)
	if (locale === "it") return it_builds_timeline_baseline(inputs)
	if (locale === "hu") return hu_builds_timeline_baseline(inputs)
	if (locale === "nl") return nl_builds_timeline_baseline(inputs)
	if (locale === "no") return no_builds_timeline_baseline(inputs)
	if (locale === "pl") return pl_builds_timeline_baseline(inputs)
	if (locale === "pt-BR") return pt_br2_builds_timeline_baseline(inputs)
	if (locale === "pt") return pt_builds_timeline_baseline(inputs)
	if (locale === "ro") return ro_builds_timeline_baseline(inputs)
	if (locale === "fi") return fi_builds_timeline_baseline(inputs)
	if (locale === "sv") return sv_builds_timeline_baseline(inputs)
	if (locale === "vi") return vi_builds_timeline_baseline(inputs)
	if (locale === "tr") return tr_builds_timeline_baseline(inputs)
	if (locale === "cs") return cs_builds_timeline_baseline(inputs)
	if (locale === "bg") return bg_builds_timeline_baseline(inputs)
	if (locale === "ru") return ru_builds_timeline_baseline(inputs)
	if (locale === "uk") return uk_builds_timeline_baseline(inputs)
	if (locale === "ar") return ar_builds_timeline_baseline(inputs)
	if (locale === "hi") return hi_builds_timeline_baseline(inputs)
	if (locale === "th") return th_builds_timeline_baseline(inputs)
	if (locale === "ja") return ja_builds_timeline_baseline(inputs)
	if (locale === "zh-CN") return zh_cn2_builds_timeline_baseline(inputs)
	if (locale === "zh-Hant") return zh_hant1_builds_timeline_baseline(inputs)
	return ko_builds_timeline_baseline(inputs)
});
export { builds_timeline_baseline as "builds.timeline.baseline" }